import { SettingConst } from '@faire/web-api--source/types';

/**
 * Whether or not to show the new email preference page
 */
export const NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104 =
  'NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104' as SettingConst<
    'NEW_EMAIL_UNSUBSCRIBE_PREFERENCE_PAGE_241104',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
